import React from 'react';
import { Loader } from 'semantic-ui-react';
import { firstError, firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import NoRows from './NoRows';
import Error from '../errors/Error';

export const noRowsToDisplay = (items, readStatus, readErrors) => (
  items.length === 0
  && !firstError(readErrors || [])
  && !readStatus.some((r) => (r === states.PENDING))
);

const firstLoad = (items, readStatus, loading) => (
  items.length === 0 && loading && readStatus.some((r) => (r === states.PENDING)));

const nextLoad = (items, readStatus, loading) => (
  items.length > 0 && loading && readStatus.some((r) => (r === states.PENDING)));

const NoRowsWrapper = ({
  buttonIcon = 'plus',
  buttonText,
  canCreate,
  children,
  className,
  entity,
  icon,
  items,
  loading,
  onClick,
  readErrors,
  readStatus,
  showChildrenIfNoRows,
  url,
}) => {
  if (firstError(readErrors)) {
    return (<Error error={firstErrorMessage(readErrors)} className="aridhia-no-rows-wrapper-error" />);
  }

  if (noRowsToDisplay(items, readStatus, readErrors) || (firstLoad(items, readStatus, loading))) {
    return (
      <>
        {showChildrenIfNoRows && (<>{children}</>)}
        <NoRows
          className={className}
          buttonIcon={buttonIcon}
          buttonText={buttonText}
          entity={entity}
          icon={icon}
          loading={readStatus.some((r) => (r === states.PENDING))}
          onClick={canCreate ? onClick : undefined}
          url={canCreate ? url : undefined}
        />
      </>
    );
  }

  return (
    <>
      {children}
      {nextLoad(items, readStatus, loading) && (<Loader active inline="centered" size="tiny" />)}
    </>
  );
};

export default NoRowsWrapper;
